import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { ErrorsTooltipComponent } from '@shared/components/errors-tooltip/errors-tooltip.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export interface AgDotsParamsOption {
  disabled?: boolean;
  onClick: () => Promise<void> | VoidFunction;
  optionClass?: string;
  title: string;
  tooltip?: string[];
}

interface AgDotsParams extends ICellRendererParams {
  disabled?: boolean;
  options: AgDotsParamsOption[];
  tooltip?: string;
}

@Component({
  imports: [
    CdkMenuTrigger,
    CdkMenu,
    CdkMenuItem,
    IconComponent,
    NgClass,
    TooltipDirective,
    ErrorsTooltipComponent,
  ],
  styleUrls: ['./ag-dots.component.scss'],
  template: `
    <div class="dots-trigger" [cdkMenuTriggerFor]="!params.disabled ? menu : null">
      @if (params.disabled) {
        <aux-icon
          name="DotsVertical"
          class="cursor-not-allowed text-aux-gray-dark"
          [auxTooltip]="params.tooltip || ''"
          [size]="20"
        />
      }
      @if (!params.disabled) {
        <aux-icon name="DotsVertical" [size]="20" />
      }
      <ng-template #menu>
        <div class="menu" cdkMenu>
          @for (option of options; track option) {
            <button
              class="menu-item"
              cdkMenuItem
              (click)="option.onClick()"
              [ngClass]="option.optionClass"
              [disabled]="!!option.disabled"
              [template]="
                option.tooltip && option.tooltip.length > 1 ? errorArrayTooltip : undefined
              "
              [auxTooltip]="tooltip(option)"
            >
              {{ option.title }}

              <ng-template #errorArrayTooltip>
                <aux-errors-tooltip [errors]="option.tooltip || []" />
              </ng-template>
            </button>
          }
        </div>
      </ng-template>
    </div>
  `,
})
export class AgDotsComponent implements ICellRendererAngularComp {
  options: AgDotsParamsOption[] = [];
  params!: AgDotsParams;

  agInit(params: AgDotsParams): void {
    this.params = params;
    this.options = this.params.options.filter((option) => option);
  }

  refresh(): boolean {
    return false;
  }

  tooltip(option: AgDotsParamsOption): string {
    return option.tooltip?.length === 1 ? option.tooltip[0] : '';
  }
}
